import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      borderRadius: theme.spacing(2)
    },
    title: {
      textAlign: 'center',
      margin: 0,
      padding: theme.spacing(2),
      borderBottom: '1px solid #6e6e6e'
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
      float: 'right'
    },
    noDataMessage: {
      textAlign: 'center'
    },
    selectBoxContainer: {
      display: 'flex',
      marginRight: 10,
      paddingLeft: 5,
      paddingBottom: 2,
      alignItems: 'center'
    },
    selectBox: {
      border: 1,
      borderStyle: 'solid',
      borderColor: '#758283',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: 5,
      overflow: 'hidden',
      padding: '0 0 0 10px',
      '@media screen and (min-width:600px)': {
        width: 200
      },
      '@media screen and (max-width:600px)': {
        width: 160
      },
      '@media screen and (max-width:450px)': {
        width: 120
      }
    },
    searchContainer: {
      alignItems: 'right'
    },
    contentContainer: {
      height: 650
    },
    loadingContainer: {
      height: 650,
      backgroundColor: '#F5F5F5'
    },
    loadingIconClearWrapper: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      marginTop: '-12px',
      marginLeft: '-100px',
      zIndex: 1
    }
  })
);
